export type KeyboardShortcutProps = {
  shortcut: string;
  separator?: string;
  testId: string;
};

const KeyboardShortcut = ({ shortcut, separator = '+', testId }: KeyboardShortcutProps) => {
  const { platform } = window.navigator;
  return (
    <span data-testid={testId}>{`${
      platform.toLowerCase().indexOf('mac') > -1 ? '⌘' : 'Ctrl'
    }${separator}${shortcut}`}</span>
  );
};

export default KeyboardShortcut;
